import React, { useState, useEffect } from "react"
import Model from "../../Models/Model.js"
const AuthContext = React.createContext()
function AuthProvider(props) {
    const [user, setUser] = useState({});
    useEffect(() => { 
        const api = new Model();
        api.postReq('/token/verify',{},(values) =>{
            if (values === null) {
                user.isAuthenticated = false
                setUser(user)
                return
            }
            if (values.success) {
                var newUser = values.value
                newUser.isAuthenticated = true
                setUser(newUser)
            } else {
                setUser({
                    isAuthenticated : false
                })
            }
        })
    }, user.isAuthenticated)

    return (
        <AuthContext.Provider value={{user, setUser}} {...props} >
            {props.children}
        </AuthContext.Provider>
    )
}
function authenticate(username, password, authManager, callback) {
    const api = new Model();
    api.postReq('/login',{
        username: username,
        password : password
    },(values,err) => {
        let current_path = window.location.pathname
        console.log(current_path)
        console.log(values)
        if (values.success) {
            if (values?.value?.state === "set-2fa"){
                callback(true,{
                    isAuthenticated : false,
                    state : "set-2fa"
                })
                return
            }
            if (values?.value?.state === "2fa"){
                callback(true,{
                    isAuthenticated : false,
                    state : "2fa",
                })
                return
            }
            const val = values.value
            localStorage.setItem("userId",val.userId)
            api.postReq('/token/verify',{
                token : val.token
            },(values) =>{
                if (values === null) {
                    callback(false,{
                        isAuthenticated : false
                    })
                    return
                }
                if (values.success) {
                    var newUser = values.value
                    newUser.isAuthenticated = true
                    authManager.setUser(newUser)
                } else if (values.success && current_path.includes("/parent")) {
                        window.location = "/student/gallery/" + values?.value?.family?.familyId
                } else {
                    authManager.setUser({
                        isAuthenticated : false
                    })
                }
                callback(values.success,newUser)
            })
        } else {
            authManager.setUser({
                isAuthenticated : false
            })
            callback(values.success,{
                isAuthenticated : false
            })
        }
    })
}
function logout(authManager) {
    localStorage.removeItem('userId');
    const api = new Model();
    api.postReq('/logout',{},(values) =>{})
    authManager.setUser({
        isAuthenticated : false
    })
}
const useAuth = () => React.useContext(AuthContext)
function withAuthManager(Component) {
    const C = props => {
      const { wrappedComponentRef, ...remainingProps } = props;
      return (
        <AuthContext.Consumer>
          {({user, setUser}) => {
                return (
                <Component
                    {...remainingProps}
                    user ={user} 
                    ref={wrappedComponentRef}
                />
                );
          }}
        </AuthContext.Consumer>
      );
    };
    C.WrappedComponent = Component;
    return C;
}
export {AuthProvider, useAuth, AuthContext, authenticate, logout, withAuthManager}